import { useCallback, useState } from 'react'
import { Channel, MessageState, OrderSummary, RiskConfig } from '../types'
import { buildFallbackMessage } from '../riskConfig'

/**
 * TEMPORARY MOCK — use this in place of useMessageDraft while testing the UI.
 * Skips the real fetch() to api.anthropic.com and just returns the fallback
 * copy after a short fake delay, so you can confirm tabs/loading/regenerate
 * all work before wiring the real endpoint back in.
 *
 * Swap back to the real ./useMessageDraft.ts once the UI is confirmed working.
 */

interface UseMessageDraftArgs {
    order: OrderSummary
    outstandingAmount: number
    creditLimit: number
    percentUsed: number
    risk: RiskConfig
    fmt: (n: number) => string
}

const FAKE_DELAY_MS = 500

export function useMessageDraft({ order }: UseMessageDraftArgs) {
    const [messages, setMessages] = useState<MessageState>({
        whatsapp: buildFallbackMessage('whatsapp', order),
        sms: null,
        email: null,
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const generate = useCallback(
        async (channel: Channel) => {
            setLoading(true)
            setError(null)
            await new Promise((resolve) => setTimeout(resolve, FAKE_DELAY_MS))
            setMessages((prev) => ({ ...prev, [channel]: buildFallbackMessage(channel, order) }))
            setLoading(false)
        },
        [order],
    )

    return { messages, loading, error, generate }
}
